import { ApiStatusCode } from "./types";

export const hasResult = (state: ApiStatusCode) => state > 199;
